// extracted by mini-css-extract-plugin
module.exports = {"container":"Unauthorised_container__26GzW","iconColor":"Unauthorised_iconColor__1rnQv","bold":"Unauthorised_bold__3jSvb","light":"Unauthorised_light__1FBQv"};